import { render } from "./features_panel.vue?vue&type=template&id=34643e8b"
import script from "./features_panel.js?vue&type=script&lang=js&external"
export * from "./features_panel.js?vue&type=script&lang=js&external"

import "./features_panel.vue?vue&type=style&index=0&id=34643e8b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__